export default __webpack_public_path__ + "static/media/request-center-16px.e6a24618.svg";